import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/settlementManage'
import BaseStore from '@store/table'

class Store extends BaseStore {
  @observable id

  $listApi = Api.cashApi

  @observable detail = {}
  @action
  getDetail = async () => {
    const { id } = this
    this.$getList(1, { id })
    let { data, success } = await Api.getDetailApi({ id })
    if (success) {
      runInAction(() => {
        this.detail = data || {}
      })
    }
  }
}
export default new Store()
